(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collapsible-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.collapsible-section summary');
    if (!summary) return;

    const details = summary.closest('details');
    if (!details || details.dataset.appsNotified === 'true') return;

    details.dataset.appsNotified = 'true';
    setTimeout(() => window.dispatchEvent(new Event('resize')), 300);
  });

  } catch(e) { console.error(e); }
})();
})();
